import { createContext } from 'react';
const DialogContext = createContext(null);
export default DialogContext;